import Hero from "../../components/Hero/Hero";
import Footer from "../../components/Footer/Footer";
import ContactForm from "./ContactForm";
const AboutImg =
  "https://images.unsplash.com/photo-1587560699334-cc4ff634909a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";

function Contact() {
  return (
    <div>
      <Hero
        cName="hero-mid"
        heroImg={AboutImg}
        title="Contact"
        btnClass="hide"
      />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default Contact;
